import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = 'https://staff.praxisamring-hameln.de';

// Get auth token from localStorage or cookies
const getAuthToken = () => {
  return (
    localStorage.getItem('authToken') ||
    Cookies.get('jwtToken') ||
    null
  );
};

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${getAuthToken()}`,
    'Content-Type': 'application/json',
  },
});

// Doctor service methods
export const doctorService = {
  // Get all doctors
  getAllDoctors: async () => {
    try {
      console.log('[doctorService] GET /doctors/doctors', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/doctors/doctors`
      });
      const response = await apiClient.get('/doctors/doctors');
      return response.data;
    } catch (error) {
      console.error('Error fetching doctors:', error);
      throw error;
    }
  },

  // Get single doctor by ID
  getDoctorById: async (id) => {
    try {
      console.log('[doctorService] GET /doctors/doctors/:id', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/doctors/doctors/${id}`
      });
      const response = await apiClient.get(`/doctors/doctors/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching doctor:', error);
      throw error;
    }
  },

  // Create new doctor
  createDoctor: async (doctorData) => {
    try {
      const formData = new FormData();
      
      // Add file if provided
      if (doctorData.profilePhoto) {
        formData.append('profilePhoto', doctorData.profilePhoto);
      }
      
      // Add other fields
      formData.append('firstName', doctorData.firstName);
      formData.append('lastName', doctorData.lastName);
      formData.append('title', doctorData.title || '');
      formData.append('specialty', doctorData.specialty);
      formData.append('description', doctorData.description || '');
      
      // Handle qualifications - convert array to comma-separated string
      if (doctorData.qualifications) {
        const qualificationsString = Array.isArray(doctorData.qualifications) 
          ? doctorData.qualifications.join(',')
          : doctorData.qualifications;
        formData.append('qualifications', qualificationsString);
      }

      const logPayload = {
        url: `${API_BASE_URL}/doctors/add-doctor`,
        token: getAuthToken(),
        formDataKeys: Array.from(formData.keys()),
        formDataValues: Array.from(formData.entries()),
      };
      console.log('[doctorService] POST /doctors/add-doctor', logPayload);

      const response = await axios.post(`${API_BASE_URL}/doctors/add-doctor`, formData, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating doctor:', error);
      throw error;
    }
  },

  // Update doctor
  updateDoctor: async (id, doctorData) => {
    try {
      const formData = new FormData();
      
      console.log('doctorData received in service:', doctorData);
      console.log('profilePhoto in doctorData:', doctorData.profilePhoto);
      
      // Add file if provided
      if (doctorData.profilePhoto) {
        console.log('Adding profilePhoto to FormData:', doctorData.profilePhoto.name, doctorData.profilePhoto.size);
        formData.append('profilePhoto', doctorData.profilePhoto);
      } else {
        console.log('No profilePhoto provided in doctorData');
      }
      
      // Add other fields
      formData.append('firstName', doctorData.firstName);
      formData.append('lastName', doctorData.lastName);
      formData.append('title', doctorData.title || '');
      formData.append('specialty', doctorData.specialty);
      formData.append('description', doctorData.description || '');
      
      // Handle qualifications
      if (doctorData.qualifications) {
        const qualificationsString = Array.isArray(doctorData.qualifications) 
          ? doctorData.qualifications.join(',')
          : doctorData.qualifications;
        formData.append('qualifications', qualificationsString);
      }

      const logPayload = {
        url: `${API_BASE_URL}/doctors/update-doctor/${id}`,
        token: getAuthToken(),
        formDataKeys: Array.from(formData.keys()),
        formDataValues: Array.from(formData.entries()),
        hasProfilePhoto: formData.has('profilePhoto')
      };
      console.log('[doctorService] PUT /doctors/update-doctor/:id', logPayload);

      const response = await axios.put(`${API_BASE_URL}/doctors/update-doctor/${id}`, formData, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating doctor:', error);
      throw error;
    }
  },

  // Delete doctor (soft delete)
  deleteDoctor: async (id) => {
    try {
      console.log('[doctorService] DELETE /doctors/delete-doctor/:id', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/doctors/delete-doctor/${id}`
      });
      
      const response = await axios.delete(`${API_BASE_URL}/doctors/delete-doctor/${id}`, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting doctor:', error);
      throw error;
    }
  },

  // Permanently delete doctor
  permanentlyDeleteDoctor: async (id) => {
    try {
      console.log('[doctorService] DELETE /doctors/permanently-delete-doctor/:id', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/doctors/permanently-delete-doctor/${id}`
      });
      
      const response = await axios.delete(`${API_BASE_URL}/doctors/permanently-delete-doctor/${id}`, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error permanently deleting doctor:', error);
      throw error;
    }
  },
};
